import { render, staticRenderFns } from "./TechAdvantages.vue?vue&type=template&id=33395050&scoped=true&"
import script from "./TechAdvantages.vue?vue&type=script&lang=js&"
export * from "./TechAdvantages.vue?vue&type=script&lang=js&"
import style0 from "./TechAdvantages.vue?vue&type=style&index=0&id=33395050&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33395050",
  null
  
)

export default component.exports